import type { UserCreateInput, UserUpdateInput } from '@plane/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createUser, fetchUsers, updateUser } from '@/modules/users/services/users.service';

/** Chave de query do domínio. Tudo que mexe na lista invalida esta raiz. */
const CHAVE = ['users'] as const;

export function useUsers(page: number, perPage: number) {
  return useQuery({
    queryKey: [...CHAVE, { page, perPage }],
    queryFn: () => fetchUsers(page, perPage),
    // Mantém a página anterior visível enquanto a próxima carrega, em vez de
    // piscar o estado de carregamento a cada troca.
    placeholderData: (anterior) => anterior,
  });
}

function useInvalidarLista() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: CHAVE });
}

export function useCreateUser() {
  const invalidar = useInvalidarLista();

  return useMutation({
    mutationFn: (input: UserCreateInput) => createUser(input),
    onSuccess: invalidar,
  });
}

export function useUpdateUser() {
  const invalidar = useInvalidarLista();

  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UserUpdateInput }) => updateUser(id, input),
    onSuccess: invalidar,
  });
}
